import { render, staticRenderFns } from "./yichangchuli.vue?vue&type=template&id=8bb1c370&scoped=true&"
import script from "./yichangchuli.vue?vue&type=script&lang=ts&"
export * from "./yichangchuli.vue?vue&type=script&lang=ts&"
import style0 from "./yichangchuli.vue?vue&type=style&index=0&id=8bb1c370&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bb1c370",
  null
  
)

export default component.exports